/**
 * UC-11: CreatePolicy
 * TOGAF Application ABB — create a policy draft from a template without UI deps.
 */
import type { Policy } from '../../../types/policy';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IPolicyManager } from '../../domain/ports/IPolicyManager';

export interface CreatePolicyInput {
  templateId: string;
  customization: Partial<Policy>;
}

export interface CreatePolicyOutput {
  ok: boolean;
  policy?: Policy;
  error?: string;
}

export interface CreatePolicyDependencies {
  policyManager: IPolicyManager;
  logger?: IAppLogger;
}

export class CreatePolicyUseCase {
  constructor(private readonly deps: CreatePolicyDependencies) {}

  execute(input: CreatePolicyInput): CreatePolicyOutput {
    try {
      const policy = this.deps.policyManager.createPolicy(
        input.templateId,
        input.customization,
      );

      this.deps.logger?.log('debug', 'policy.created', {
        policyId: policy.id,
        templateId: input.templateId,
        name: policy.name,
      });

      return { ok: true, policy };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      this.deps.logger?.log('warn', 'policy.create_failed', {
        templateId: input.templateId,
        error: message,
      });
      return { ok: false, error: message };
    }
  }
}